/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
	display:flex;
	justify-content: space-between;
	align-items: flex-end;
	color: #3b3b3b;
	line-height: 1;
`;

const Text = styled.span`
	${({big}) => big ? 'font-size: 40px;' : ''}
	${({medium}) => medium ? 'font-size: 25px;' : ''}
	${({bold}) => bold ? 'font-weight: 700;' : ''}
	${({blue}) => blue ? 'color: #43abf3;' : ''}
	${({wrapped}) => wrapped
    ? `
			background: #fff;
			padding: 8px 31px 10px;
			border-radius: 3px;
		`
    : ''
    }

	& + span {
		margin-left: 33px;
	}
`;

const Header = ({
                    quantity,
                    shortNumber,
                    workplace,
                    due,
                    step,
                    maxSteps,
                }) => (
    <Wrapper>
        <Text big bold>
            Fehler melden
        </Text>

        <span>
			<Text bold medium>{shortNumber}</Text>

			<Text bold medium>{quantity}</Text> Stk.
		</span>
    </Wrapper>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/task/working/report/header.js